import { KioskService } from './kiosk.service';
import { KioskTimeoutService } from '@modules/kiosk/services/kiosk-timeout.service';

export const services = [KioskService, KioskTimeoutService];

export * from './kiosk.service';
export * from './kiosk-timeout.service';
